import React, { useState } from 'react';

import MainFont from 'ui/typography/mainFont';
import { ClickOutside } from 'ui/atoms';
import { LanguagesPopup } from 'ui/components';
import { getLanguageData } from 'utils/common';
import {
  ArrowContainer,
  ChosenLanguage,
  DownArrow,
  FlagImage,
  LanguageContainer
} from './style';

const LanguageSelection = ({ changeLanguageFallback }) => {
  const [
    showLanguageSelectionDropdown,
    setShowLanguageSelectionDropdown
  ] = useState(false);

  const handleLanguage = lang => {
    changeLanguageFallback(lang);
  };

  return (
    <ClickOutside callback={() => setShowLanguageSelectionDropdown(false)}>
      <LanguageContainer
        onClick={() => {
          setShowLanguageSelectionDropdown(!showLanguageSelectionDropdown);
        }}
      >
        <ChosenLanguage>
          <FlagImage src={getLanguageData().flag} />
          <MainFont type="blueLabel" configuration={{ fontWeight: 600 }}>
            {getLanguageData().code.toUpperCase()}
          </MainFont>
          <ArrowContainer>
            <DownArrow upsideDown={!showLanguageSelectionDropdown} />
            {showLanguageSelectionDropdown && (
              <LanguagesPopup
                handleClose={() => {
                  setShowLanguageSelectionDropdown(false);
                }}
                handleLanguageFallback={handleLanguage}
              />
            )}
          </ArrowContainer>
        </ChosenLanguage>
      </LanguageContainer>
    </ClickOutside>
  );
};

LanguageSelection.propTypes = {};

export default LanguageSelection;
